// @flow
import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { maintenanceCostAllocationApi } from '../../lib/api';
import { type MaintenanceCostAllocation } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/maintenance-cost-allocation/';

export default (props: PageProps) => {
  const [data: MaintenanceCostAllocation, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await maintenanceCostAllocationApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: MaintenanceCostAllocation) => {
    let id = payload.id;
    if (id) {
      await maintenanceCostAllocationApi.update(payload);
    } else {
      let data = await maintenanceCostAllocationApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: MaintenanceCostAllocation) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Распределение затрат на ТО'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
